import { ImportLanesAPI } from '../../../api/datamanager/ImportLanesAPI';

export class ImportLanesCommand {
    constructor() {
        this.importLanesApi = new ImportLanesAPI();
    }

    uploadFile(data, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", data.file);
        dataToSend.append("type", data.dataType);
        dataToSend.append("countyEdition", data.lane.obj.countyEdition);

        const apiResult = this.importLanesApi.uploadFile(dataToSend);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(Object.assign(result, { message: "Dados carregados com sucesso" }));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/datamanager/commands/ImportLanesCommand.js